import { Box, Link, MenuItem, Stack, TextField, Typography } from "@mui/material";

import { usePriorities } from "../../Support/consts";

type Props = {
  onChange: (value: string) => void;
  value: string;
  canOpenUrgentTicket?: boolean;
  onEscalate?: () => void;
};

export const SeverityDropdown = ({ onChange, value, canOpenUrgentTicket, onEscalate }: Props) => {
  const priorities = usePriorities();

  return (
    <TextField
      select
      required
      fullWidth
      value={value}
      label="Severity"
      size="medium"
      data-cy="severity-dropdown"
      onChange={(event) => {
        onChange(event.target.value);
      }}
      slotProps={{
        select: {
          MenuProps: {
            sx: { maxHeight: "460px", maxWidth: "300px", zIndex: 1201 },
          },
        },
      }}
    >
      {priorities.map((priority) => (
        <MenuItem
          key={priority.value}
          value={priority.value}
          disabled={!canOpenUrgentTicket && priority.value === "urgent"}
        >
          <Stack direction="row" alignItems="center">
            <Box
              sx={{
                width: 6,
                height: 24,
                backgroundColor: priority.color,
                marginRight: 1,
                borderRadius: 8,
              }}
            />

            {priority.title}
          </Stack>
        </MenuItem>
      ))}
      {onEscalate && !canOpenUrgentTicket && (
        <Box
          component="li"
          data-cy="severity-payment-footer"
          sx={{
            bgcolor: "background.paper",
            borderTop: "1px solid",
            borderColor: "divider",
            px: 2,
            py: 0.6,
            textAlign: "center",
            mt: 1,
          }}
        >
          <Typography variant="body1">
            <Link sx={{ textDecoration: "none", cursor: "pointer" }} onClick={onEscalate}>
              Escalate this ticket
            </Link>{" "}
            to 'Production system down' with a one-time payment of $750
          </Typography>
        </Box>
      )}
    </TextField>
  );
};
